import { defineComponent as y, inject as O, h as c, Transition as P } from "vue";
import { internalSelectionMenuInjectionKey as S } from "./ghl-ui.es1430.js";
import M from "./ghl-ui.es721.js";
import { render as $ } from "./ghl-ui.es1002.js";
import { mergeEventHandlers as g } from "./ghl-ui.es1088.js";
import w from "./ghl-ui.es894.js";
import F from "./ghl-ui.es1117.js";
function j(n, o) {
  return c(P, { name: "fade-in-scale-up-transition" }, {
    default: () => n ? c(w, { clsPrefix: o, class: `${o}-base-select-option__check` }, {
      default: () => c(F)
    }) : null
  });
}
const B = y({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    const {
      valueRef: o,
      pendingTmNodeRef: l,
      multipleRef: u,
      valueSetRef: h,
      renderLabelRef: s,
      renderOptionRef: r,
      labelFieldRef: m,
      valueFieldRef: p,
      showCheckmarkRef: b,
      nodePropsRef: k,
      handleOptionClick: N,
      handleOptionMouseEnter: d
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = O(S), f = M(() => {
      const { value: t } = l;
      return t ? n.tmNode.key === t.key : !1;
    });
    function e(t) {
      const { tmNode: i } = n;
      i.disabled || N(t, i);
    }
    function a(t) {
      const { tmNode: i } = n;
      i.disabled || d(t, i);
    }
    function R(t) {
      const { tmNode: i } = n, { value: v } = f;
      i.disabled || v || d(t, i);
    }
    return {
      multiple: u,
      isGrouped: M(() => {
        const { tmNode: t } = n, { parent: i } = t;
        return i && i.rawNode.type === "group";
      }),
      showCheckmark: b,
      nodeProps: k,
      isPending: f,
      isSelected: M(() => {
        const { value: t } = o, { value: i } = u;
        if (t === null)
          return !1;
        const v = n.tmNode.rawNode[p.value];
        if (i) {
          const { value: C } = h;
          return C.has(v);
        } else
          return t === v;
      }),
      labelField: m,
      renderLabel: s,
      renderOption: r,
      handleMouseMove: R,
      handleMouseEnter: a,
      handleClick: e
    };
  },
  render() {
    const { clsPrefix: n, tmNode: { rawNode: o }, isSelected: l, isPending: u, isGrouped: h, showCheckmark: s, nodeProps: r, renderOption: m, renderLabel: p, handleClick: b, handleMouseEnter: k, handleMouseMove: N } = this, d = j(l, n), f = p ? [p(o, l), s && d] : [
      $(o[this.labelField], o, l),
      s && d
    ], e = r == null ? void 0 : r(o), a = c(
      "div",
      Object.assign({}, e, { class: [
        `${n}-base-select-option`,
        o.class,
        e == null ? void 0 : e.class,
        {
          [`${n}-base-select-option--disabled`]: o.disabled,
          [`${n}-base-select-option--selected`]: l,
          [`${n}-base-select-option--grouped`]: h,
          [`${n}-base-select-option--pending`]: u,
          [`${n}-base-select-option--show-checkmark`]: s
        }
      ], style: [(e == null ? void 0 : e.style) || "", o.style || ""], onClick: g([b, e == null ? void 0 : e.onClick]), onMouseenter: g([
        k,
        e == null ? void 0 : e.onMouseenter
      ]), onMousemove: g([N, e == null ? void 0 : e.onMousemove]) }),
      c("div", { class: `${n}-base-select-option__content` }, f)
    );
    return o.render ? o.render({ node: a, option: o, selected: l }) : m ? m({ node: a, option: o, selected: l }) : a;
  }
});
export {
  B as default
};
